var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoPunto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: 29.601559,
    height: 29.896484,
    viewBox: "0 0 29.601559 29.896484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88.717491,-84.686126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fill: "#bebec0",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 0.686407
    },
    d: "m 103.51925,97.628508 c -1.10842,-7.07e-4 -2.00744,0.897446 -2.00781,2.00586 3.7e-4,1.108412 0.89939,2.006572 2.00781,2.005862 1.10765,-3.7e-4 2.00549,-0.89821 2.00586,-2.005862 -3.7e-4,-1.107653 -0.89821,-2.00549 -2.00586,-2.00586 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoPunto);
export default __webpack_public_path__ + "static/media/fondo_punto.9537e26bf08ca24fafb9f54e3194f5eb.svg";
export { ForwardRef as ReactComponent };